import { graphql } from '../../generated';

export const UPDATE_ORDER_ITEMS = graphql(`
  mutation UpdateOrderItems(
    $orderId: ID!
    $itemIds: [ID!]!
    $personalIdentifier: String
    $deliveryId: ID
    $invoiceId: ID
    $price: Float
    $vatPercentage: Float
  ) {
    updateOrderItems(
      input: {
        orderId: $orderId
        itemIds: $itemIds
        personalIdentifier: $personalIdentifier
        deliveryId: $deliveryId
        invoiceId: $invoiceId
        price: $price
        vatPercentage: $vatPercentage
      }
    ) {
      order {
        id
      }
    }
  }
`);

export const REMOVE_ITEMS_FROM_ORDER = graphql(`
  mutation RemoveItemsFromOrder($itemIds: [ID!]!, $blockReason: String) {
    removeItemsFromOrder(input: { itemIds: $itemIds, blockReason: $blockReason }) {
      order {
        id
      }
    }
  }
`);

export const REMOVE_AND_BLOCK_ITEMS_FROM_ORDER = graphql(`
  mutation RemoveAndBlockItemsFromOrder($itemIds: [ID!]!, $blockedItemIds: [ID!]!, $blockReason: String!) {
    released: removeItemsFromOrder(input: { itemIds: $itemIds }) {
      order {
        id
      }
    }
    blocked: removeItemsFromOrder(input: { itemIds: $blockedItemIds, blockReason: $blockReason }) {
      order {
        id
      }
    }
  }
`);
